export default __webpack_public_path__ + "static/media/margaret-mead.aa03af4b.png";